<nav class="navbar navbar-vertical fixed-start navbar-expand-lg navbar-light" id="sidebar">

  @if (environment() === 'development') {
    <div class="banner development d-print-none">Development</div>
  }
  @if (environment() === 'local') {
    <div class="banner local d-print-none">Local</div>
  }

  <div class="container-fluid">

    <!-- Toggler -->
    <button aria-controls="sidebarCollapse" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
      data-bs-target="#sidebarCollapse" data-bs-toggle="collapse" type="button">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Brand -->
    <a class="navbar-brand" href="../../../index.html">
      <img alt="..." class="navbar-brand-img mx-auto" src="../../../assets/images/logo-blue@3x.png">
    </a>

    <!-- User (xs) -->
    <div class="navbar-user d-md-none ">

      <!-- Dropdown -->
      <div class="dropdown  d-print-none">

        <!-- Toggle -->
        <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-bs-toggle="dropdown" href="#"
          id="sidebarIcon" role="button">
          <div class="avatar avatar-sm avatar-online">
            <img [src]="pictureUrl" alt="..." class="avatar-img rounded-circle">
          </div>
        </a>

        <!-- Menu -->
        <div aria-labelledby="sidebarIcon" class="dropdown-menu dropdown-menu-end">
          <span class="dropdown-item text-dark">{{ email }}</span>
          <a class="dropdown-item" routerLink="/account/general">Mon compte</a>
          <hr class="dropdown-divider">
          <a class="dropdown-item" routerLink="/logout">Se déconnecter</a>
        </div>

      </div>

    </div>

    <!-- Collapse -->
    <div class="collapse navbar-collapse" id="sidebarCollapse">

      <!-- Form -->
      <!--            <form class="mt-4 mb-3 d-md-none">-->
      <!--                <div class="input-group input-group-rounded input-group-merge input-group-reverse">-->
      <!--                    <input class="form-control" type="search" placeholder="Search" aria-label="Search">-->
      <!--                    <div class="input-group-text">-->
      <!--                        <span class="fe fe-search"></span>-->
    <!--                    </div>-->
  <!--                </div>-->
<!--            </form>-->

<!-- Navigation -->
<ul class="navbar-nav">
  <li class="nav-item">
    <a [class.active]="this.menuService.menuItems['/'].isActive" aria-controls="sidebarDashboards"
      class="nav-link" role="button"
      routerLink="/">
      <i class="fal fa-home icon fa-fw me-2"></i> Vue d'ensemble
    </a>
  </li>
  <!--                <li class="nav-item">-->
  <!--                    <a class="nav-link" href="#sidebarPages" data-bs-toggle="collapse" role="button" aria-expanded=""-->
  <!--                       aria-controls="sidebarPages">-->
  <!--                          <i class="fal fa-file icon"></i>-->
  <!--                           Mandats-->
<!--                    </a>-->
<!--                    <div class="collapse" [class.show]="this.menuService.menuItems['/mandates'].isActive || this.menuService.menuItems['/mandates/create'].isActive" id="sidebarPages">-->
<!--                        <ul class="nav nav-sm flex-column">-->
<!--                            <li class="nav-item">-->
<!--                                <a routerLink="/mandates/create" class="nav-link" [class.active]="this.menuService.menuItems['/mandates/create'].isActive" role="button"-->
<!--                                   aria-expanded="" aria-controls="sidebarAccount">-->
<!--                                    Créér un nouveau mandat-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="nav-item">-->
<!--                                <a href="#sidebarAccount" [class.active]="this.menuService.menuItems['/mandates'].isActive" class="nav-link" role="button"-->
<!--                                   aria-expanded="" aria-controls="sidebarAccount">-->
<!--                                    Liste des mandats-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                    <a class="nav-link" href="#clients-personal" data-bs-toggle="collapse" role="button" aria-expanded=""-->
<!--                       aria-controls="clients-personal">-->
<!--                        <i class="fal fa-user icon"></i>-->
<!--                        Clients particuliers-->
<!--                    </a>-->
<!--                    <div class="collapse" [class.show]="this.menuService.menuItems['/clients/personal'].isActive || this.menuService.menuItems['/clients/personal/create'].isActive" id="clients-personal">-->
<!--                        <ul class="nav nav-sm flex-column">-->
<!--                            <li class="nav-item">-->
<!--                                <a routerLink="/clients/personal/create" class="nav-link" [class.active]="this.menuService.menuItems['/clients/personal/create'].isActive" role="button"-->
<!--                                   aria-expanded="" aria-controls="sidebarAccount">-->
<!--                                    Créér un nouveau client (particulier)-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="nav-item">-->
<!--                                <a routerLink="/clients/personal"  [class.active]="this.menuService.menuItems['/clients/personal'].isActive" class="nav-link" role="button"-->
<!--                                   aria-expanded="" aria-controls="sidebarAccount">-->
<!--                                    Liste des clients particuliers-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                    <a class="nav-link" href="#clients-corporate" data-bs-toggle="collapse" role="button" aria-expanded=""-->
<!--                       aria-controls="clients-corporate">-->
<!--                        <i class="fal fa-building icon"></i>-->
<!--                        Clients corporatifs-->
<!--                    </a>-->
<!--                    <div class="collapse" [class.show]="this.menuService.menuItems['/clients/corporate'].isActive || this.menuService.menuItems['/clients/corporate/create'].isActive" id="clients-corporate">-->
<!--                        <ul class="nav nav-sm flex-column">-->
<!--                            <li class="nav-item">-->
<!--                                <a routerLink="/clients/corporate/create" class="nav-link" [class.active]="this.menuService.menuItems['/clients/corporate/create'].isActive" role="button"-->
<!--                                   aria-expanded="" aria-controls="sidebarAccount">-->
<!--                                    Créér un nouveau client corporatif-->
<!--                                </a>-->
<!--                            </li>-->
<!--                            <li class="nav-item">-->
<!--                                <a routerLink="/clients/corporate" [class.active]="this.menuService.menuItems['/clients/corporate'].isActive" class="nav-link" role="button"-->
<!--                                   aria-expanded="" aria-controls="sidebarAccount">-->
<!--                                    Liste des clients corporatifs-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </li>-->
@if (isCalculationsAvailable | async) {
  <li class="nav-item">
    <a aria-controls="tools" aria-expanded="" class="nav-link" data-bs-toggle="collapse" href="#tools"
      role="button">
      <i class="fal fa-calculator-alt icon me-2"></i>
      Calculs
    </a>
    <div [class.show]="this.menuService.menuItems['/calculations/create'] || this.menuService.menuItems['/calculations'].isActive"
      class="collapse"
      id="tools">
      <div [class.show]="this.menuService.menuItems['/calculations/create'].isActive">
        <ul class="nav nav-sm flex-column">
          @if (isCreateNewCalculationActive()) {
            <li class="nav-item">
              <a [class.active]="this.menuService.menuItems['/calculations/create'].isActive"
                aria-controls="sidebarAccount"
                aria-expanded="" class="nav-link"
                role="button" routerLink="/calculations/create">
                Créer un nouveau calcul
              </a>
            </li>
          }
        </ul>
      </div>
      <div [class.show]="this.menuService.menuItems['/calculations'].isActive">
        <ul class="nav nav-sm flex-column">
          @if (isCalculationsListActive()) {
            <li class="nav-item">
              <a [class.active]="this.menuService.menuItems['/calculations'].isActive"
                aria-controls="sidebarAccount"
                aria-expanded=""
                class="nav-link"
                role="button" routerLink="/calculations">
                Historique
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </li>
}

@if (isClientQuestionnairesAvailable | async) {
  <li class="nav-item">
    <a aria-controls="client-questionnaires" aria-expanded="" class="nav-link" data-bs-toggle="collapse"
      href="#client-questionnaires"
      role="button" style="font-size: 9pt;">
      <i class="fal fa-edit icon me-2"></i>
      Collecte de données client
    </a>
    <div [class.show]="this.menuService.menuItems['/client-questionnaires'] || this.menuService.menuItems['/client-questionnaires'].isActive"
      class="collapse"
      id="client-questionnaires">
      <div [class.show]="this.menuService.menuItems['/client-questionnaires/create'].isActive">
        <ul class="nav nav-sm flex-column">
          @if (isCreateNewClientQuestionnairesActive()) {
            <li class="nav-item">
              <a [class.active]="this.menuService.menuItems['/client-questionnaires/create'].isActive"
                aria-controls="sidebarAccount"
                aria-expanded=""
                class="nav-link"
                role="button" routerLink="/client-questionnaires/create">
                Créer un nouveau questionnaire
              </a>
            </li>
          }
        </ul>
      </div>
      <div [class.show]="this.menuService.menuItems['/client-questionnaires'].isActive">
        <ul class="nav nav-sm flex-column">
          @if (isClientQuestionnairesListActive()) {
            <li class="nav-item">
              <a [class.active]="this.menuService.menuItems['/client-questionnaires'].isActive"
                aria-controls="sidebarAccount"
                aria-expanded=""
                class="nav-link"
                role="button" routerLink="/client-questionnaires">
                Liste des questionnaires
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </li>
}


<!--                <li class="nav-item d-md-none">-->
<!--                    <a class="nav-link" data-bs-toggle="offcanvas" href="#sidebarOffcanvasActivity"-->
<!--                       aria-contrtols="sidebarOffcanvasActivity">-->
<!--                        <span class="fe fe-bell"></span> Notifications-->
<!--                    </a>-->
<!--                </li>-->
</ul>

<!-- Divider -->
<hr class="navbar-divider my-3">

<!-- Heading -->
<h6 class="navbar-heading">
  Administration
</h6>

<!-- Navigation -->
<ul class="navbar-nav mb-md-4">
  <li class="nav-item">
    <a [class.active]="this.menuService.menuItems['/organization/settings'].isActive"
      aria-controls="sidebarBasics"
      aria-expanded="" class="nav-link"
      role="button"
      routerLink="/organization/settings">
      <i class="fal fa-cogs icon me-2"></i> Paramètres généraux
    </a>
  </li>

  <li class="nav-item">
    <a [class.active]="this.menuService.menuItems['/organization/employees'].isActive"
      aria-controls="sidebarBasics"
      aria-expanded="" class="nav-link"
      role="button"
      routerLink="/organization/employees">
      <i class="fal fa-users icon me-2"></i> Employés
    </a>
  </li>
  <li class="nav-item">
    <a [class.active]="this.menuService.menuItems['/organization/billing'].isActive" aria-controls="sidebarBasics"
      aria-expanded="" class="nav-link"
      role="button"
      routerLink="/organization/billing">
      <i class="fal fa-credit-card icon me-2"></i> Paiement et facturation
    </a>
  </li>
  <!--                <li class="nav-item">-->
  <!--                    <a class="nav-link" href="#employees" [class.active]="" role="button" aria-expanded=""-->
  <!--                       aria-controls="sidebarBasics">-->
  <!--                        <i class="fal fa-plus-octagon icon"></i> Achat de calculs additionnels-->
<!--                    </a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                    <a class="nav-link"  routerLink="/organization/billing"  [class.active]="this.menuService.menuItems['/organization/billing'].isActive" role="button" aria-expanded=""-->
<!--                       aria-controls="sidebarBasics">-->
<!--                        <i class="fal fa-credit-card icon"></i> Vos informations de paiement-->
<!--                    </a>-->
<!--                </li>-->
</ul>

<!-- Push content down -->
<div class="mt-auto"></div>


<!-- User (md) -->
<div class="navbar-user d-none d-md-flex" id="sidebarUser">

  <!-- Icon -->
  <!--                <a class="navbar-user-link" data-bs-toggle="offcanvas" href="#sidebarOffcanvasActivity"-->
  <!--                   aria-controls="sidebarOffcanvasActivity">-->
  <!--            <span class="icon">-->
  <!--              <i class="fe fe-bell"></i>-->
<!--            </span>-->
<!--                </a>-->

<!-- Dropup -->
<div class="dropup">

  <!-- Toggle -->
  <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-bs-toggle="dropdown" href="#"
    id="sidebarIconCopy" role="button">
    <div class="avatar avatar-sm avatar-online">
      <img [src]="pictureUrl" class="avatar-img rounded-circle">
    </div>
  </a>

  <!-- Menu -->
  <div aria-labelledby="sidebarIconCopy" class="dropdown-menu">
    <span class="dropdown-item text-dark">{{ email }}</span>
    <a class="dropdown-item" routerLink="/account/general">Mon compte</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item" routerLink="/logout">Se déconnecter</a>
  </div>

</div>

<!-- Icon -->
<!--                <a class="navbar-user-link" data-bs-toggle="offcanvas" href="#sidebarOffcanvasSearch"-->
<!--                   aria-controls="sidebarOffcanvasSearch">-->
<!--            <span class="icon">-->
<!--              <i class="fe fe-search"></i>-->
<!--            </span>-->
<!--                </a>-->

</div>

</div> <!-- / .navbar-collapse -->

</div>
</nav>
